export const CREATE_GLOBAL_ITEM_REQUESTED =
  'CREATE_GLOBAL_ITEM_REQUESTED'
export const CREATE_GLOBAL_ITEM_SUCCEEDED =
  'CREATE_GLOBAL_ITEM_SUCCEEDED'
export const CREATE_GLOBAL_ITEM_FAILED = 'CREATE_GLOBAL_ITEM_FAILED'

export const GET_GLOBAL_ITEM_REQUESTED = 'GET_GLOBAL_ITEM_REQUESTED'
export const GET_GLOBAL_ITEM_SUCCEEDED = 'GET_GLOBAL_ITEM_SUCCEEDED'
export const GET_GLOBAL_ITEM_FAILED = 'GET_GLOBAL_ITEM_FAILED'

export const GET_FILTERED_AND_PAGINATED_ITEMS_REQUESTED =
  'GET_FILTERED_AND_PAGINATED_ITEMS_REQUESTED'
export const GET_FILTERED_AND_PAGINATED_ITEMS_SUCCEEDED =
  'GET_FILTERED_AND_PAGINATED_ITEMS_SUCCEEDED'
export const GET_FILTERED_AND_PAGINATED_ITEMS_FAILED =
  'GET_FILTERED_AND_PAGINATED_ITEMS_FAILED'

export const UPDATE_TOGGLE = 'UPDATE_TOGGLE'

export const UPDATE_GLOBAL_ITEM_REQUESTED =
  'UPDATE_GLOBAL_ITEM_REQUESTED'
export const UPDATE_GLOBAL_ITEM_SUCCEEDED =
  'UPDATE_GLOBAL_ITEM_SUCCEEDED'
export const UPDATE_GLOBAL_ITEM_FAILED = 'UPDATE_GLOBAL_ITEM_FAILED'

export const REMOVE_GLOBAL_ITEM_REQUESTED =
  'REMOVE_GLOBAL_ITEM_REQUESTED'
export const REMOVE_GLOBAL_ITEM_SUCCEEDED =
  'REMOVE_GLOBAL_ITEM_SUCCEEDED'
export const REMOVE_GLOBAL_ITEM_FAILED = 'REMOVE_GLOBAL_ITEM_FAILED'

export const SEARCH_GLOBAL_ITEM_SUCCEEDED =
  'SEARCH_GLOBAL_ITEM_SUCCEEDED'

export const ADD_ITEM_FILTERS_BY_MENU = 'ADD_ITEM_FILTERS_BY_MENU'
export const ADD_ITEM_FILTERS_BY_CATEGORY =
  'ADD_ITEM_FILTERS_BY_CATEGORY'
export const ADD_ITEM_FILTERS_BY_INVENTORY_STATE =
  'ADD_ITEM_FILTERS_BY_INVENTORY_STATE'

export const SET_ITEMS_INDEXES_IN_MODIFIER_GROUPS =
  'SET_ITEMS_INDEXES_IN_MODIFIER_GROUPS'

export const SET_ITEMS_INDEXES = 'SET_ITEMS_INDEXES'
export const CLEAR_ITEMS_INDEXES = 'CLEAR_ITEMS_INDEXES'
